import { useSelect } from '@wordpress/data';
import { useEffect } from '@wordpress/element';
import { STORE_NAME } from '../store';

const { flowEW } = window;

export default function PublishGuard() {
  const review = useSelect((sel) => sel(STORE_NAME).getReview(), []);
  const isAlreadyPublished = useSelect(
    (sel) => sel('core/editor').getCurrentPostAttribute('status') === 'publish',
    []
  );
  const fromReview = Number(
    review?.reviewer_id ?? review?.reviewer?.id ?? 0
  );
  const fromMeta = Number( flowEW.reviewerMeta ?? 0 );
  const reviewerId = fromReview > 0 ? fromReview : fromMeta;
  const isApproved =
    review?.status === 'approved' && reviewerId > 0;
  const blocked =
    flowEW.reviewMandatory && !isAlreadyPublished && !isApproved;

  useEffect(() => {
    const styleId = 'flow-ew-publish-guard';

    if (blocked) {
      let el = document.getElementById(styleId);
      if (!el) {
        el = document.createElement('style');
        el.id = styleId;
        document.head.appendChild(el);
      }
      el.textContent = `
        .editor-post-publish-button,
        .editor-post-publish-button__button {
          opacity: 0.4 !important;
          pointer-events: none !important;
          cursor: not-allowed !important;
        }
        .editor-post-schedule__panel-dropdown,
        .editor-post-schedule__dialog-toggle {
          opacity: 0.4 !important;
          pointer-events: none !important;
          cursor: not-allowed !important;
        }
      `;
    } else {
      const el = document.getElementById(styleId);
      if (el) {
        el.parentNode.removeChild(el);
      }
    }
  }, [blocked]);

  return null;
}
